import React from 'react';

import classNames from 'classnames';

import { UrlType } from '../../types/apiEnums';
import { DropDownMenuPresentational } from '../../types/common';
import { Link, LinkTarget, LinkType } from '../Link/Link';
import { Typography } from '../Typography/Typography';
import styles from './FooterLinksSection.module.css';

export const FooterLinksSection: React.FC<DropDownMenuPresentational> = React.memo(
  ({ title, menuItems, className }) => {
    return (
      <div
        className={classNames(styles.section, className)}>
        <Typography className={styles.title} variant='body2'>
          {title}
        </Typography>

        <div className={styles.links}>
          {menuItems.map(({ path, title }, idx) => {
            if (!path) {
              return null;
            }

            return path.type === UrlType.RELATIVE ? (
              <Link
                key={`link_${title}_${idx}`}
                type={LinkType.Href}
                className={styles.link}
                to={path.href}
              >
                {title}
              </Link>
            ) : (
              <Link
                key={`link_${title}_${idx}`}
                type={LinkType.ExternalHref}
                target={LinkTarget.Blank}
                className={styles.link}
                to={path.href}
              >
                {title}
              </Link>
            );
          })}
        </div>
      </div>
    );
  },
);

FooterLinksSection.displayName = 'FooterLinksSection';
